import React, {FC, useEffect, useState} from 'react';
import brandLogo from "../../../assets/media/brands/logo.svg";
import {Form, Input, Modal} from "antd";
import {MailOutlined, UserOutlined} from "@ant-design/icons";
import {useHistory} from "react-router-dom";
import {Col, Row} from 'antd';
import {Guid} from 'guid-typescript';
import UserApi from "../../../services/api/UserApi";
import {useAppDispatch} from "../../../redux/hooks";
import {hideLoading, showLoading} from "../../../redux/commonSlice";

interface ForgotPasswordProps {
}

const ForgotPassword: FC<ForgotPasswordProps> = () => {
    const history = useHistory();
    const dispatch = useAppDispatch()
    type ValidateStatus = Parameters<typeof Form.Item>[0]['validateStatus'];
    const [userName, setUserName] = useState(null);
    const [email, setEmail] = useState('');
    const [inputCaptcha, setInputCaptcha] = useState('');
    const [imageCaptcha, setImageCaptcha] = useState();
    const [base64Captcha, setBase64Captcha] = useState('');
    const [uuid, setUuid] = useState('');
    const [errorCaptcha, setErrorCaptcha] = useState<any>();
    const [firstChange, setFirstChange] = useState(false);
    const [validateType, setValidateType] = useState('onBlur')
    const [errors, setErrors] = useState({ username: false, email: false});

    const [inputEmail, setInputEmail] = useState<{
        value: string;
        validateStatus?: ValidateStatus;
        errorMessage?: string | null;
    }>({
        value: '',
    });

    useEffect(() => {
        const controller = new AbortController();
        getCaptcha();
        controller.abort()
    }, [])

    const getCaptcha = async () => {
        try {
            let uid = Guid.create().toString();
            setUuid(uid);
            dispatch(showLoading({}))
            const res = await UserApi.getCaptcha(uid, {}, {});
            setImageCaptcha(res.data.data);
            let textImage = `data:image/png;base64,${res.data.data}`;
            setBase64Captcha(textImage);
            dispatch(hideLoading());
        } catch (err: any) {
            dispatch(hideLoading());
            console.log(err);
            Modal.error({title: err?.response?.data?.message});
        }
    }

    const onChangeEmail = (value) => {
        setEmail(value.target.value)
    }

    const onChangeUserName = (value) => {
        if(firstChange){
            setErrors({...errors, username: true});
        }
        setUserName(value.target.value)
    }

    const handleOk = async (e: React.MouseEvent<HTMLElement>) => {
        console.log(e);
        setErrorCaptcha(true)
    };

    const handleForgotPassword = async () => {
        try {
            dispatch(showLoading({}))
            const res = await UserApi.forgotPassword(userName, email, inputCaptcha, uuid);
            if (res) {
                history.push('/forgot-password/success')
            }
            dispatch(hideLoading());
        } catch (err: any) {
            dispatch(hideLoading());
            console.log(err)
            if (err?.response?.data?.code === '99') {
                Modal.error({
                    title: 'Mã capcha không đúng, đề nghị nhập lại',  onOk() {getCaptcha()}});
            } else if (err?.response?.data?.code === '24') {
                Modal.error({title: 'Thông tin không hợp lệ, vui lòng kiểm tra lại'})
            } else {
                Modal.error({title: err?.response?.data?.message})
            }
        }

    }

    const handleBack = () => {
        history.push('/auth/login')
    }

    const handleBlur = (e: any) => {
        if(!firstChange){
            setFirstChange(true);
        }
        setErrors({...errors,[e.target.name]: true});
    };

    return (
        <>
            <div className="d-flex w-100 align-items-center position-relative overflow-hidden login-background-sub">
                <div className="login-wrapper">
                    <div className="login-title h1 b mb-32">
                        <img src={brandLogo} width="200" alt=""/>
                    </div>
                    <div className="box login-box">
                        <div className="form">
                            <div className="h2 font-weight-500 mb-4 text-center ff-fantasy">
                                VNPAY PORTAL INVOICE
                            </div>
                            <div
                                className="fz-h4 text-primary mb-4 text-center"
                            >
                                Quên mật khẩu
                            </div>
                            <div
                                className="fz-h4 mb-4 text-center"
                            >
                                Vui lòng nhập email và mã captcha
                            </div>
                            <Form
                                initialValues={{remember: true}}
                                onFinish={handleForgotPassword}
                                autoComplete="off"
                            >
                                <div className="form-login-inner list-mb20 list-crop">
                                    <div className="form-group">
                                        <label>
											<span className="text-danger">
												*
											</span>
                                            Tên đăng nhập
                                        </label>
                                        <Form.Item
                                            name="username"
                                            validateTrigger={validateType}
                                            rules={[{
                                                required: true,
                                                message: 'Vui lòng nhập tên đăng nhập'
                                            }, {
                                                pattern: /^[A-Za-z0-9-_@./#&+-]*$/,
                                                message: 'Chỉ cho phép nhập ký tự không dấu, ký tự đặc biệt, chữ, số, không khoảng trắng, viết liền, không phân biệt hoa thường'
                                            }]}
                                        >
                                            <Input
                                                placeholder="Tên đăng nhập"
                                                minLength={1}
                                                maxLength={50}
                                                className="form-control form-control-lg"
                                                onChange={onChangeUserName}
                                                suffix={<UserOutlined/>}
                                                onBlur={() => setValidateType('onChange')}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className="form-group">
                                        <label>
											<span className="text-danger">
												*
											</span>
                                            Email
                                        </label>
                                        <Form.Item
                                            name="email"
                                            validateTrigger={validateType}
                                            rules={[{
                                                required: true,
                                                message: 'Vui lòng nhập email'
                                            }, {
                                                pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                                                message: 'Email không đúng định dạng, vui lòng kiểm tra lại'
                                            }]}
                                        >
                                            <Input
                                                minLength={1}
                                                maxLength={50}
                                                placeholder="Email"
                                                value={inputEmail.value}
                                                onBlur={() => setValidateType('onChange')}
                                                className="form-control form-control-lg"
                                                onChange={onChangeEmail}
                                                suffix={<MailOutlined/>}
                                            />
                                        </Form.Item>
                                    </div>
                                    <div className="form-group">
                                        <label>
											<span className="text-danger">
												*
											</span>
                                            Mã Captcha
                                        </label>
                                        <Form.Item
                                            name="captcha"
                                            rules={[{required: true, message: 'Vui lòng nhập captcha'}, {
                                                pattern: /^([A-z0-9])*[^\s]\1*$/,
                                                message: 'Mã capcha không đúng, đề nghị nhập lại'
                                            }]}
                                        >
                                            <Row gutter={[16, 16]}>
                                                <Col span={14}>
                                                    <Input
                                                        onChange={(e) => setInputCaptcha(e.target.value)}
                                                        className="form-control form-control-lg"
                                                        placeholder="Nhập mã captcha"
                                                    />
                                                </Col>
                                                <Col span={10}>
                                                    <img src={base64Captcha} alt="image-captcha"/>
                                                </Col>

                                            </Row>

                                        </Form.Item>
                                    </div>
                                    <Row gutter={[48, 16]}>
                                        <Col span={12}>
                                            <Form.Item>
                                                <button onClick={handleBack}
                                                        className="btn btn-secondary btn-block btn-lg">
                                                    Quay lại
                                                </button>
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item>
                                                <button
                                                    className="btn btn-primary btn-block btn-lg rounded">
                                                    Gửi mật khẩu
                                                </button>
                                            </Form.Item>
                                        </Col>
                                    </Row>

                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )

}


export default ForgotPassword;
